import React, { createContext, useContext, useState } from "react";
import { TranslateProvider } from "autobiz-translate";
import { selectRightLanguageToApply } from "./language-context";

const LanguageContext = createContext<{ language?: any; changeLanguage?: any }>({});
LanguageContext.displayName = "LanguageContext";

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("error");
  }
  return context;
};

const AutobizTranslateProvider = ({ children }: any) => {
  const [language, setLanguage] = useState<any>(() => selectRightLanguageToApply());
  const stage = process.env.REACT_APP_ENV === "prod" ? "prod" : "dev";

  const changeLanguage = (languageChanged: any) => {
    try {
      localStorage.setItem("applanguage", languageChanged);
      setLanguage(languageChanged);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <TranslateProvider projectName="trade-app" stage={stage} language={language} key={language}>
      <LanguageContext.Provider value={{ language, changeLanguage }}>
        {children}
      </LanguageContext.Provider>
    </TranslateProvider>
  );
};

export default AutobizTranslateProvider;
